import React from "react";

// SVG recreation of the Mocha & Milk bear logo style
export default function BearLogo({ size = 48 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* Pink background circle */}
      <circle cx="50" cy="50" r="50" fill="#FFD6DC"/>

      {/* ── MOCHA (brown bear, lying down on right) ── */}
      {/* Body */}
      <ellipse cx="62" cy="68" rx="22" ry="16" fill="#C8845A" stroke="#2D1A0E" strokeWidth="2.2"/>
      {/* Head */}
      <circle cx="58" cy="55" r="17" fill="#C8845A" stroke="#2D1A0E" strokeWidth="2.2"/>
      {/* Ears */}
      <circle cx="45" cy="41" r="7" fill="#C8845A" stroke="#2D1A0E" strokeWidth="2"/>
      <circle cx="45" cy="41" r="4" fill="#E8A87C"/>
      <circle cx="70" cy="40" r="7" fill="#C8845A" stroke="#2D1A0E" strokeWidth="2"/>
      <circle cx="70" cy="40" r="4" fill="#E8A87C"/>
      {/* Face muzzle */}
      <ellipse cx="58" cy="59" rx="9" ry="7" fill="#E8A87C"/>
      {/* Eyes - sleepy lines */}
      <path d="M51 52 Q53 50 55 52" stroke="#2D1A0E" strokeWidth="1.8" strokeLinecap="round" fill="none"/>
      <path d="M61 52 Q63 50 65 52" stroke="#2D1A0E" strokeWidth="1.8" strokeLinecap="round" fill="none"/>
      {/* Nose */}
      <ellipse cx="58" cy="57" rx="2" ry="1.5" fill="#2D1A0E"/>
      {/* Blush marks (red lines) */}
      <line x1="48" y1="56" x2="51" y2="55" stroke="#E05A5A" strokeWidth="1.5" strokeLinecap="round"/>
      <line x1="48" y1="58" x2="51" y2="57" stroke="#E05A5A" strokeWidth="1.5" strokeLinecap="round"/>
      <line x1="65" y1="55" x2="68" y2="56" stroke="#E05A5A" strokeWidth="1.5" strokeLinecap="round"/>
      <line x1="65" y1="57" x2="68" y2="58" stroke="#E05A5A" strokeWidth="1.5" strokeLinecap="round"/>

      {/* ── MILK (white bear, sitting/hugging on left) ── */}
      {/* Body */}
      <ellipse cx="36" cy="70" rx="18" ry="14" fill="#F5F0EC" stroke="#2D1A0E" strokeWidth="2.2"/>
      {/* Head */}
      <circle cx="33" cy="50" r="16" fill="#F5F0EC" stroke="#2D1A0E" strokeWidth="2.2"/>
      {/* Ears */}
      <circle cx="21" cy="37" r="6.5" fill="#F5F0EC" stroke="#2D1A0E" strokeWidth="2"/>
      <circle cx="21" cy="37" r="3.5" fill="#F9D0D8"/>
      <circle cx="44" cy="36" r="6.5" fill="#F5F0EC" stroke="#2D1A0E" strokeWidth="2"/>
      <circle cx="44" cy="36" r="3.5" fill="#F9D0D8"/>
      {/* Face muzzle */}
      <ellipse cx="33" cy="54" rx="8" ry="6" fill="#F9D0D8"/>
      {/* Eyes - happy closed */}
      <path d="M26 48 Q28 46 30 48" stroke="#2D1A0E" strokeWidth="1.8" strokeLinecap="round" fill="none"/>
      <path d="M36 48 Q38 46 40 48" stroke="#2D1A0E" strokeWidth="1.8" strokeLinecap="round" fill="none"/>
      {/* Nose + mouth */}
      <ellipse cx="33" cy="52" rx="1.8" ry="1.3" fill="#2D1A0E"/>
      <path d="M30 54 Q33 57 36 54" stroke="#2D1A0E" strokeWidth="1.5" strokeLinecap="round" fill="none"/>
      {/* Blush cheeks */}
      <ellipse cx="25" cy="53" rx="4" ry="2.5" fill="#F9A0B0" opacity="0.7"/>
      <ellipse cx="41" cy="53" rx="4" ry="2.5" fill="#F9A0B0" opacity="0.7"/>

      {/* Hugging arm over mocha */}
      <path d="M44 62 Q55 58 68 63" stroke="#F5F0EC" strokeWidth="7" strokeLinecap="round" fill="none"/>
      <path d="M44 62 Q55 58 68 63" stroke="#2D1A0E" strokeWidth="2" strokeLinecap="round" fill="none"/>
    </svg>
  );
}
